<template>
  <router-link
    exact-active-class="active"
    class="nav-link current"
    data-dismiss="modal"
    :to="toWhere"
    tag="li"
  >
    <span class="icon"><i :class="iconMenu" /></span>
    <span
      data-feather="home"
    />
    <span class="menu-name">{{ menuItem }}</span> <span class="sr-only">(current)</span>
  </router-link>
</template>

<script>
export default {
  name: "Menuitems",
  props: ["menuItem", "iconMenu", "toWhere"],
  data() {
    return {
      currentPath: "",
    };
  },
  created() {
    this.path = this.$route.path;
  },
  methods: {
    navigateTo: function () {
      return this.$router.push(this.toWhere);
    },
  },
};
</script>

<style scoped>
.icon {
  padding: 0 10px;
}

li.active {
  background:#faffe1;
}
li.active > span{
  color: #8bc34a;
}
@media only screen and (min-device-width : 768px) and (max-device-width : 1023px){
 .icon {
   display: none;
 }
 .menu-name {
   font-size: 9pt;
 }
}
</style>
